import type { DashboardQuery } from '../../../api/engagementMetrics';
import { ExportFilterValue, formatExportDate } from '../../../lib/export';

export interface EngagementFilterState {
  query: DashboardQuery;
  brgNameById: Map<number, string>;
}

/**
 * Renders the dashboard's active filters for the PDF header so a recipient can
 * tell exactly which slice of data the charts reflect.
 */
export function buildEngagementExportFilters(
  state: EngagementFilterState
): ExportFilterValue[] {
  const brgId = state.query.brgId ?? 'all';
  const brgValue =
    brgId === 'all'
      ? 'All BRGs'
      : state.brgNameById.get(Number(brgId)) ?? `BRG ${brgId}`;

  return [
    { label: 'BRG', value: brgValue },
    { label: 'Company', value: state.query.company?.trim() || 'All Companies' },
    {
      label: 'Period 1',
      value: `${formatExportDate(state.query.p1Start)} – ${formatExportDate(state.query.p1End)}`,
    },
    {
      label: 'Period 2',
      value: `${formatExportDate(state.query.p2Start)} – ${formatExportDate(state.query.p2End)}`,
    },
  ];
}
